import { IncomingMessage } from "http";
import { buildExpressRequestPagesRouter } from "./express-request";
import { getStorePresentationInstance } from "./store-presentation-provider";

export const getVersionManifest = async (req: IncomingMessage) => {
  const store = getStorePresentationInstance();
  const { request } = await buildExpressRequestPagesRouter(req);
  const versionManifest = await store.getVersionManifest({
    request,
    response: {},
  });

  return versionManifest;
};
